<template>
  <div>
    <!-- 配送服务警告提示横幅（isAllow === 0 且有提示时展示） -->
    <div
      v-if="isAllow === 0 && addressConstant"
      class="adress_notice_msg_all font12 font_weight400"
    >
      <img
        src="@/assets/order/icon_warning@2x.png"
        alt=""
        class="adress_notice_msg_all_icon"
      />
      <span>{{ addressConstant }}</span>
    </div>

    <!-- 配送方式选择 -->
    <div class="content_all logistics-service-row">
      <div class="listrow font12 font_weight500">
        <div class="listrow_left clb045">配送服务</div>
        <div class="listrow_right flex_right">
          <div
            v-for="type in logisticsTypeList"
            :key="type"
            class="option_item"
            @click="changeLogisticsType(type)"
          >
            <img
              :src="logisticsType == type ? selectImg : unSelectImg"
              class="option_radio_icon"
            />
            <span
              class="option_label"
              :class="{ color_huang: logisticsType == type }"
            >
              {{ type == 0 ? "自提" : type == 1 ? "本地配送" : "直邮" }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LogisticsSelect",
  props: {
    logisticsType: {
      type: [Number, String],
      default: null
    },
    logisticsTypeList: {
      type: Array,
      default() {
        return [];
      }
    },
    isAllow: {
      type: Number,
      default: 1
    },
    addressConstant: {
      type: String,
      default: ""
    },
    selectImg: {
      type: String,
      required: true
    },
    unSelectImg: {
      type: String,
      required: true
    }
  },
  methods: {
    changeLogisticsType(type) {
      this.$emit("change", type);
    }
  }
};
</script>

<style lang="less" scoped>
.adress_notice_msg_all {
  min-height: 36px;
  width: 100%;
  background: #fcf8d9;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: #dd9132;
  padding: 6px 12px;
  box-sizing: border-box;

  .adress_notice_msg_all_icon {
    width: 16px;
    height: 16px;
    margin-right: 12px;
    flex-shrink: 0;
  }
}

.content_all {
  background-color: white;
  overflow: hidden;
  margin: 12px 0 0;
}

.listrow {
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.listrow_left {
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.45);
}

.listrow_right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.flex_right {
  display: flex;
  justify-content: flex-end;
  flex: auto;
  align-items: center;
}

.option_item {
  display: flex;
  align-items: center;
  margin-left: 15px;
  cursor: pointer;

  .option_radio_icon {
    width: 16px;
    height: 16px;
    margin-right: 4px;
    flex-shrink: 0;
  }

  .option_label {
    font-size: 12px;
    font-weight: 500;
    color: #383838;

    &.color_huang {
      color: #bf9264;
    }
  }
}
</style>
